import React, { useState, useRef} from 'react'


function Calculator({getValue,totalCO2}) {

  //! Range values

  const  [people,setPeople] =useState (1);
  const  [wastes,setWastes] =useState (1);
  const  [bottle,setBottle] =useState (1);
  const  [bottleExist,setBottleExist] =useState (0);
  const  [travel,setTravel]=useState(0);
  const  [car,setCar]=useState(0);


  //! Calculator Values

  const inputContinent = useRef();
  const selectDiet = useRef();
  const selectOrganicWaste = useRef();
  const selectSeparatedWate = useRef();
  const [country,setCountry] = useState("0.4589");

  const  [inputKwh,setInputKwh]=useState("");
  const  [inputNaturalGas,setInputNaturalGas]=useState("");
  const  [optionGasBottleCapacity,setOptionGasBottleCapacity]=useState(0);


  const  [planeLongTravel,setPlaneLongTravel]=useState("");
  const  [planeMediumTravel,setPlaneMediumTravel]=useState("");
  const  [planeShortTravel,setPlaneShortTravel]=useState("");
  const  [trainLongTravel,setTrainLongTravel]=useState("");
  const  [subTrainTravel,setSubTrainTravel]=useState("0");
  const  [bussTravel,setBussTravel]=useState("0");

  const  [gasolineCars,setGasolineCars]=useState("");
  const  [gasolineCarsUse,setGasolineCarsUse]=useState("");

  const  [CNGCars,setCNGCars]=useState("");
  const  [CNGCarsUse,setCNGCarsUse]=useState("");

  const  [motorcycle,setMotorcycle]=useState("");
  const  [motorcycleUse,setMotorcycleUse]=useState("");

 


  


  return (
    <div className="d-flex flex-row">
    <div className='col-12 col-md-8'>
                       
                  

    {/*Principal section*/}

        <div className='d-flex flex-column mt-2 p-5'>

            <h1 className="fw-bold green">En casa</h1>
            <div>
              <p className="grey fs-4">¿En qué parte del mundo vives?</p>
              <select className="form-select form-select-lg mb-3" aria-label=".form-select-lg example" ref={inputContinent}>
                <option selected value={1}>Sur américa</option>
                <option value={0.75}>Europa</option>
                <option value={0.5}>Asia</option>
                <option value={0.7}>África</option>
                <option value={1}>Norte América</option>
              </select>
            </div>
            <div>
              <div className='d-flex justify-content-between align-items-center'>
                   <label for="customRange1" className="grey fs-4 regularText">¿Cuántas personas viven en tu hogar?</label>
                   <span className="minText">{people} Personas</span>
              </div>
              <input type="range" className="form-range" id="customRange1" min={1} max={20} step="1" value={people} onChange={e => setPeople(e.target.value)}></input>
            </div>       
          </div>

          {/**Food section */}
          <div className='mt-4 p-5 d-flex flex-column'>
              <h1 className="fw-bold green">Comida y desechos</h1>
              <p className="grey fs-4">Acerca de tu dieta</p>
              <select className="form-select form-select-lg mb-3" aria-label=".form-select-lg example" ref={selectDiet}>
                <option selected value="1500">Vegano</option>
                <option value="1700">Vegetariano</option>
                <option value="1900">Rara vez como carne</option>
                <option value="3300">Dieta normal</option>
                <option value="4400">Amante de la carne</option>
              </select>

              <div className='d-flex justify-content-between align-items-center'>
                  <label for="wasteRange" className="form-label">Desde 1 (un poco) a 3 (mucho) ¿Cuántos residuos crees se generan en tu casa?</label>
                  <span className="minText">{wastes} </span>
              </div>
              <input type="range" className="form-range" min="1" max="3" step="1" value={wastes} onChange={e => setWastes(e.target.value)}></input>

              <p className="grey fs-4">Tratado de los desechos en casa</p>
              <select className="form-select form-select-lg mb-3" aria-label=".form-select-lg example" ref={selectOrganicWaste}>
                <option selected value="111">Composto en casa</option>
                <option value="790">No composto en casa</option>
              </select>
              <select className="form-select form-select-lg mb-3" aria-label=".form-select-lg example" ref={selectSeparatedWate}>
                <option selected value="25">Separo mi basura y llevo a reciclar</option>
                <option value="50">Tiro junta toda mi basura</option>
              </select>
        </div>


        {/**Electricity consumption */}
        <div className='mt-4 p-5 d-flex flex-column'>
            <h1 className='green fw-bold'>Consumo de electricidad</h1>
            <p className="grey fs-4">Tu país:</p>
            <select className="form-select form-select-lg mb-3" aria-label=".form-select-lg example" defaultValue="0.4589" onChange={e => setCountry(e.target.value)}>
                <option value="0.4589">Argentina</option>
                <option value="0.4314">Mexico</option>
                <option value="0.1643">Colombia</option>
                <option value="0.4187">Chile</option>
                <option value="0.617">Brasil</option>
                <option value="0.4367">Perú</option>
                <option value="0.2449">Ecuador</option>
                <option value="0.42394">United States</option>
                <option value="0.45091">España</option>
                <option value="0.12">Canada</option>
                <option value="0.4">Otro...</option>
                
              </select>

            <div>
                  <label className="grey fs-4 regularText " htmlFor='kwaInput'>Consumo de electricidad por año (kWh)</label>
                  <input type="number" className='form-control' placeholder="0.00 kWh" value={inputKwh} onChange={e => setInputKwh(e.target.value)}/>
                  <p className="minText">Debes sumar los kWh (kilowats por hora) de las boletas de tus ultimos 12 meses de pagos de luz.</p>
            </div>


        </div>

        {/**Gas consumption */}
        <div className='mt-4 p-5 d-flex flex-column'>
            <h1 className='green fw-bold'>Consumo de Gas</h1>
            <label className="grey fs-4 regularText ">Gas natural</label>
            <input type="number" className='form-control' placeholder="0.00 m3"  value={inputNaturalGas} onChange={e => setInputNaturalGas(e.target.value)}/>
            <p className="minText">Consumo de gas natural en metros cubicos (m3) del último año, puedes ayudarte sumando las ultimas boletas de gas directo.</p>

            <p className="grey fs-4">Gas de garrafa</p>
             <select className="form-select form-select-lg mb-3" aria-label=".form-select-lg example" defaultChecked="0"  onChange={e => setBottleExist(e.target.value)}>
                <option value="0">No uso</option>
                <option value="1">Si uso</option>
              </select>

              {bottleExist==="1" &&
              <div>
                  <p className="grey fs-4">Capacidad de mi garrafa:</p>
                  <select className="form-select form-select-lg" aria-label=".form-select-lg example" defaultValue="0" onChange={e => setOptionGasBottleCapacity(e.target.value)}>
                      <option disabled="disabled" value="0">0 kg</option>
                      <option  value="29.6">10 kg</option>
                      <option value="103.6">35 kg</option>
                      <option value="133.22">45 kg</option>
                      <option value="222">75 kg</option>
                      <option value="14.8">menos de 10 kg</option>

                  </select>


                  <div className='d-flex justify-content-between align-items-center'>
                        <label for="gasBottleRange" className="form-label">¿Cuántas garrafas consumes aproximadamente por año?</label>
                        <span className="minText">{bottle} garrafas </span>
                  </div>
                  <input type="range" class="form-range" min="0" max="30" step="1" id="gasBottleRange" value={bottle} onChange={e => setBottle(e.target.value)}></input>
                  <p className="minText"> Garrafas de Gas butano o propano</p>
              </div>
              }

        </div>

        {/**Travels*/}
        <div className='mt-4 p-5 d-flex flex-column'>
        <h1 className='green fw-bold'>Viajes</h1>

        
        <p className="grey fs-4">¿Viajaste durante los últimos 12 meses? (usando tren o avión)</p>
          <select className="form-select form-select-lg mb-3" aria-label=".form-select-lg example" defaultValue='0' onChange={e => setTravel(e.target.value)}>
            <option value="0">No :(</option>
            <option value="1">Si :)</option>
         </select>

        {
          travel==="1" &&
          <div className="py-5">
            
            <h3 className="pb-4">Viajes en Avión</h3> 

            <label className="grey fs-4 regularText" htmlFor="planeShortTravel">¿Realizaste viajes corta distancia en avión? ingresa los kilómetros (km) recorridos.</label>
            <input className='form-control' type="number" id='planeShortTravel'  value={planeShortTravel} onChange={e => setPlaneShortTravel(e.target.value)} placeholder="0.00 km"/> 
            <p className="pb-5">Distancias cortas: menos de 800 km (por ejemplo: vuelos locales cortos, sin salir del país). Puedes ayudarte coon google para saber cuantos kilometros hay de una ciudad a otra.</p>

            <label className="grey fs-4 regularText" htmlFor="planeMediunTravel">¿Realizaste viajes de media distancia en avión? ingresa los kilómetros (km) recorridos.</label>
            <input className='form-control' type="number" id='planeMediunTravel' value={planeMediumTravel} onChange={e => setPlaneMediumTravel(e.target.value)} placeholder="0.00 km"/> 
            <p className="pb-5">Distancias medias: entre 800 km y 3,700 km (por ejemplo, de Buenos Aires a Santiago de Chile, 1,400 km). Puedes ayudarte coon google para saber cuantos kilometros hay de una ciudad a otra.</p>

            <label className="grey fs-4 regularText" htmlFor="planeLongTravel">¿Realizaste viajes larga distancia en avión? ingresa los kilómetros (km) recorridos.</label>
            <input className='form-control' type="number" id='planeLongTravel' value={planeLongTravel} onChange={e => setPlaneLongTravel(e.target.value)} placeholder="0.00 km"/> 
            <p className="pb-5">Distancias largas: más de 3,700 km (Por ejemplo, de Buenos Aires a Ciudad de México 7,300 km). Puedes ayudarte coon google para saber cuantos kilometros hay de una ciudad a otra.</p>

            <h3 className="pb-4">Viajes en tren</h3>  

            <label className="grey fs-4 regularText" htmlFor="trainTravel">¿Cuántos kilómetros viajaste en trenes de larga distancia? por ejemplo el tren Tucuman-Buenos Aires</label>
            <input className='form-control' type="number" id='trainTravel' value={trainLongTravel} onChange={e => setTrainLongTravel(e.target.value)} placeholder="0.00 km"/> 
            <p className="minText">No son válidos trenes urbanos (por ejemplo: el tren al desarrollo)</p>       

          </div>
        }
        
        </div>

        {/**Vehicles*/}
        <div className='mt-4 p-5 d-flex flex-column'>
            <h1 className='green fw-bold pb-3'>Transporte</h1>

            <div className="col-12 d-flex flex-row flex-wrap mb-5">

              <div className='col-12 col-md-6 d-flex flex-column align-items-center'>
                  <img width="200px" src="https://cdn-icons-png.flaticon.com/512/543/543885.png" alt="buss" />
                  <div>
                      <label className="grey fs-4 regularText" htmlFor="bussTravel">Si viajas casi a diario en colectivo ¿cuántos km recorres de viaje?</label>
                      <input className='form-control' type="number" id='bussTravel' value={bussTravel} onChange={e => setBussTravel(e.target.value)} placeholder="0.00 km"/> 
                      <p className="minText">Por ejemplo: viajo a diario 2 km para ir a la universidad.</p>
                  </div>
              </div>
              
              <div className='col-12 col-md-6 d-flex flex-column align-items-center'>
                <img width="200px" src="https://cdn-icons-png.flaticon.com/512/2836/2836243.png" alt="train" />
                <div>
                    <label className="grey fs-4 regularText" htmlFor="subTravel">Si viajas casi a diario en tren ¿cuántos km recorres en cada viaje?</label>
                    <input className='form-control' type="number" id='subTravel' value={subTrainTravel} onChange={e => setSubTrainTravel(e.target.value)} placeholder="0.00 km"/> 
                    <p className="minText">Por ejemplo: viajo a diario 2 km para ir a la universidad.</p> 
                </div>
              </div>

            </div>

            





            <p className="grey fs-4 pt-5">¿Posees algún vehículo a motor en casa?</p>
              <select className="form-select form-select-lg mb-3" aria-label=".form-select-lg example" defaultValue='0' onChange={e => setCar(e.target.value)}>
                <option value="0">No </option>
                <option value="1">Si </option>
              </select>
            
            {car ==="1" &&
            <div className="col-12 d-flex flex-row flex-wrap">
              
                <div className='col-12 col-md-6 d-flex flex-column align-items-center'>
                <img width="200px" src="https://cdn-icons-png.flaticon.com/512/2554/2554936.png" alt="car" />
                    <div className="gasoline py-3">
                          <label className="grey fs-4 regularText" htmlFor='inputGasolineCars'>Autos a gasolina o nafta</label>
                          <input className="form-control" name="inputGasolineCars" type="number" id="inputGasolineCars" value={gasolineCars} onChange={e=> setGasolineCars(e.target.value)} placeholder="Ingrese la cantidad de vehículos que posee"/>
                          <label htmlFor="inputGasolineCarsUse">Cantidad de km recorridos por estos vehiculos en el último año</label>
                          <input className="form-control" name="inputGasolineCarsUse" type="number" id="inputGasolineCarsUse" value={gasolineCarsUse}onChange={e=> setGasolineCarsUse(e.target.value)}  placeholder="Ingrese los kilómetros"/>
                    </div>
                </div>

                <div className='col-12 col-md-6 d-flex flex-column align-items-center'>
                <img width="200px" src="https://cdn-icons-png.flaticon.com/512/171/171239.png" alt="gas" />
                  <div className="CNG py-3">
                        <label  className="grey fs-4 regularText" htmlFor='inputCNGCars'>Autos a gas</label>
                        <input className="form-control" name="inputCNGCars" type="numbers" id="inputCNGCars" value={CNGCars} onChange={e=> setCNGCars(e.target.value)} placeholder="Ingrese la cantidad de vehículos que posee"/>
                        <label htmlFor="inputCNGCarsUse">Cantidad de km recorridos por estos vehiculos en el último año</label>
                        <input className="form-control" name="inputCNGCarsUse" type="numbers" id="inputCNGCarsUse" value={CNGCarsUse} onChange={e=> setCNGCarsUse(e.target.value)}  placeholder="Ingrese los kilómetros"/>
                  </div>
                </div>



                <div className='col-12 col-md-6 d-flex flex-column align-items-center'>
                <img width="200px" src="https://img.freepik.com/iconos-gratis/moto_318-936112.jpg?w=2000" alt="moto" />
                  <div className="Motorcycle py-3">
                        <label className="grey fs-4 regularText" htmlFor='inputMotorcycle'>Moto</label>
                        <input className="form-control" name="inputMotorcycle" type="numbers" id="inputMotorcycle" value={motorcycle}  onChange={e=> setMotorcycle(e.target.value)} placeholder="Ingrese la cantidad de motos que posee"/>
                        <label htmlFor="inputCNGCarsUse">Cantidad de km recorridos por estos vehiculos en el último año</label>
                        <input className="form-control" name="inputMotorcycleUse" type="numbers" id="inputMotorcycleUse" value={motorcycleUse} onChange={e=> setMotorcycleUse(e.target.value)}  placeholder="Ingrese los kilómetros"/>
                  </div>
                </div>

                
            </div>
            }

          
            <p className="fs-4 green pt-5">Vehículos eléctricos y bicicletas no generan emisiones de CO2.</p>
        </div>

  


        <div className='pt-4 mt-5 text-center rounded-2'>
          <h1 className="tittleText fw-bold green">TOTAL</h1>
          <p className="regularText fs-4 grey">{parseInt(totalCO2)}kg CO2 Eq  </p>
        </div>

        <div className="text-center pb-5">        
        
               {
                inputNaturalGas !=="" && inputKwh!=="" &&
                <button className='btn btn-lg btn-success tittleText fs-2 fw-bold mb-4' 
                  onClick={() => getValue(
                    inputContinent.current.value,
                    people,
                    selectDiet.current.value,
                    wastes,
                    selectOrganicWaste.current.value,
                    selectSeparatedWate.current.value,
                    country,
                    inputKwh,
                    inputNaturalGas,
                    optionGasBottleCapacity,
                    bottle,
                    planeShortTravel,
                    planeMediumTravel,
                    planeLongTravel,
                    trainLongTravel,
                    subTrainTravel,
                    bussTravel,
                    gasolineCarsUse,
                    CNGCarsUse,
                    motorcycle,
                    motorcycleUse
                    )}
                >Calcular</button>
               }
               {

                inputNaturalGas ===""  || inputKwh==="" ?
                <button className='btn btn-lg btn-danger tittleText fs-2 fw-bold  mb-4' disabled >Complete los datos</button>
                :
                <span></span>

               }
               

        </div>

        </div>
        <div className='col-12 col-md-4 mt-2 p-5'>
                        <h1>Total</h1>
                        <hr />
                        <span className="regularText fs-4">{parseInt(totalCO2)}</span>
                        <span className="regularText fs-4">kg CO2eq</span>
        </div>

    </div>

  )
}

export default Calculator